import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { AppSettingsService } from 't4-app-integration';
import { ActiveRentalService, LayoutService } from 'app-components';


@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.css'],
  standalone: false
})
export class ChatbotComponent implements OnInit {
  zendeskKey = 'fa045ccb-5bab-4193-bff5-7ec511bf2836';
  lang = 'sv';
  private zendeskReady?: Promise<void>;
  constructor(private renderer: Renderer2, public appSettings: AppSettingsService, private layout: LayoutService, private activeRentalService: ActiveRentalService) { }

  private isOnewayContext(): boolean {
    return this.appSettings.contextId?.toLowerCase() === '43d09b7e-079a-4b29-83cb-abbc928a7358';
  }


  ngOnInit(): void {
    if (this.appSettings.appType == 'app') {
      setTimeout(() => {
        if (this.appSettings.contextId.toLowerCase() == 'kanleiesunmanned_api') this.loadZendeskScript();
        if (this.appSettings.contextId.toLowerCase() == '24rentalunmanned_api') this.loadAmidra('eyJUZW5hbnRJZCI6ImJyZW5kZXJ1cC1yZW50YWwiLCJCcmFuZElkIjozfQ==');
        if (this.appSettings.contextId.toLowerCase() == '43d09b7e-079a-4b29-83cb-abbc928a7358') this.loadAmidra('eyJUZW5hbnRJZCI6ImJyZW5kZXJ1cC1yZW50YWwiLCJCcmFuZElkIjo1fQ==');
      }, 100);
    }
  }

  loadZendeskScript(): void {
    if (document.getElementById('ze-snippet')) {
      this.hideLauncher();      
    }
    
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.id = 'ze-snippet';
    script.charset = 'utf-8';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${this.zendeskKey}`;
    script.onload = () => {
      (window as any).zE("messenger:set", 'locale', this.appSettings.language);
      this.hideLauncher();
    };

    script.onerror = (error) => { console.error('Error loading the zendesk script:', error); };

    this.renderer.appendChild(document.head, script);
  }

  private hideLauncher() {
    this.onReady(() => {
      try { (window as any).zE('messenger', 'hide'); } catch { }
    });
  }

  private onReady(fn: () => void) {
    (this.zendeskReady ?? Promise.resolve()).then(fn);
  }

  public openChat() {
    (window as any).AmidraChat('open');

    this.onReady(() => {
      (window as any).zE('messenger', 'show');
      (window as any).zE('messenger', 'open');
      (window as any).zE('messenger:on', 'close', () => {
        (window as any).zE('messenger', 'hide');
      });
    });
  }

  loadAmidra(data:string): void {
    if (document.getElementById('amidra-chat-bootstrap')) {
      this.hideLauncher();
    }

    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.id = 'amidra-chat-bootstrap';
    script.charset = 'utf-8';
    script.src = `https://chat.amidra.se/amidra-chat.bootstrap.js`;
    script.setAttribute('data-amidra', data);

    script.onload = () => {
      (window as any).AmidraChat("set", "showLauncher", false);

      (window as any).AmidraChat("on", "clientTool.openSwapTrailerUI", (params: any) => {
        if (params.bookingId) {
          this.activeRentalService.navigateToSwapTrailer(parseInt(params.bookingId));
          setTimeout(() => (window as any).AmidraChat('close'), 3000);
        }
      });

      if (!this.isOnewayContext()) {
        (window as any).AmidraChat("on", "clientTool.openChangeTimeUI", (params: any) => {
          if (params.bookingId) {
            this.activeRentalService.navigateToChangeTime(parseInt(params.bookingId));
            setTimeout(() => (window as any).AmidraChat('close'), 3000);
          }
        });

        (window as any).AmidraChat("on", "clientTool.openChangeLocationUI", (params: any) => {
          if (params.bookingId) {
            this.activeRentalService.navigateToChangeLocation(parseInt(params.bookingId));
            setTimeout(() => (window as any).AmidraChat('close'), 3000);
          }
        });

        (window as any).AmidraChat("on", "clientTool.openChangeObjectUI", (params: any) => {
          if (params.bookingId) {
            this.activeRentalService.navigateToChangeObject(parseInt(params.bookingId));
            setTimeout(() => (window as any).AmidraChat('close'), 3000);
          }
        });
      }

      if (this.appSettings.userLoggedIn && this.appSettings.customer?.Email) {
        (window as any).AmidraChat('identify', { email: this.appSettings.customer.Email });
      }
    };

    script.onerror = (error) => { console.error('Error loading the zendesk script:', error); };

    this.renderer.appendChild(document.head, script);
  }


}
